import MentoringDescription from './MentoringDescription.vue';

export default MentoringDescription;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/description/index.ts